import { Component, computed, Inject, model, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { NgSelectComponent, NgSelectModule } from "@ng-select/ng-select";
import { EligibilityProvider } from '../../../models/eligibility-provider';
import { EligibilityTechnology } from '../../../models/eligibility-technology';
import { TechnicalEligibilityApiService } from '../../../services/technical-eligibility-api-service';
import { FormsModule } from '@angular/forms';
import { HoverClassDirective } from '../../../directives/hover-class-directive';
import { NgClass } from '@angular/common';
import { SessionService } from '../../../services/session-service';
import { SnackBarService } from '../../../services/snack-bar-service';
import { MatInputModule } from "@angular/material/input";
import { MatCheckboxModule } from "@angular/material/checkbox";

@Component({
  selector: 'app-run-eligibility-modal-component',
  imports: [
    MatDialogModule,
    NgSelectModule,
    NgSelectComponent,
    MatButtonModule,
    FormsModule,
    NgClass,
    HoverClassDirective,
    MatInputModule,
    MatCheckboxModule
],
  templateUrl: './run-eligibility-modal-component.html',
})
export class RunEligibilityModalComponent {
  
  public readonly providers = signal<EligibilityProvider[]>([]);
  public readonly technologies = signal<EligibilityTechnology[]>([]);

  public availableProviders!: EligibilityProvider[];
  public availableTechnologies!: EligibilityTechnology[];

  public readonly selectedProviders = model<EligibilityProvider[]>([]);
  public readonly selectedTechnologies = model<EligibilityTechnology[]>([]);

  public readonly canRunTechnicalEligibilty = computed<boolean>(() => {
    return this.selectedProviders().length > 0 && 
      this.selectedTechnologies().length > 0 &&
      this.siteIds().length > 0 &&
      this.computingTechnicalEligibility() === false;
  });

  public readonly siteIds = computed<number[]>(() => this.relaunchAllSites() ? this.data.siteIds : this.data.eligibleSiteIds)

  public readonly computingTechnicalEligibility = signal<boolean>(false);
  public readonly relaunchAllSites = model<boolean>(false);

  constructor(
    private readonly technicalEligibilityApiService: TechnicalEligibilityApiService,
    private readonly sessionService: SessionService,
    private readonly snackBar: SnackBarService,
    private readonly dialogRef: MatDialogRef<RunEligibilityModalComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: any
  ) {}

  /**
   * SELECT METHODS
   */

  ngOnInit() {
    this.technicalEligibilityApiService.getProviders().subscribe({
      next: (response: EligibilityProvider[]) => {
        this.providers.set(response);
        this.availableProviders = response;
      }
    });

    this.technicalEligibilityApiService.getTechnologies().subscribe({
      next: (response: EligibilityTechnology[]) => {
        this.technologies.set(response);
        this.availableTechnologies = response;

        this.selectedTechnologies.set(this.availableTechnologies.filter(technology => technology.default));
      }
    });
  }

  isAllProvidersSelected(): boolean {
    return this.selectedProviders().length === this.availableProviders.length;
  }

  isAllTechnologiesSelected(): boolean {
    return this.selectedTechnologies().length === this.availableTechnologies.length;
  }

  toggleSelectAllProviders(event?: any): void {
    let selectAll = !this.isAllProvidersSelected();

    if (event) {
      selectAll = event.target.checked;
    }

    if (selectAll) {
      this.selectedProviders.set([...this.availableProviders]);
    } else {
      this.selectedProviders.set([]);
    }
  }

  toggleSelectAllTechnologies(event?: any): void {
    let selectAll = !this.isAllTechnologiesSelected();

    if (event) {
      selectAll = event.target.checked;
    }

    if (selectAll) {
      this.selectedTechnologies.set([...this.availableTechnologies]);
    } else {
      this.selectedTechnologies.set([]);
    }
  }

  /**
   * USER ACTIONS
   */

  requestTechnicalEligibility(): void {
    this.sessionService.requestTechnicalEligibility(
      this.sessionService.currentSessionCode(), 
      this.selectedProviders().map((provider: EligibilityProvider) => provider.name), 
      this.selectedTechnologies().map((technology: EligibilityTechnology) => technology.name), 
      this.siteIds()
    ).subscribe({
      next: (res: any) => {
        this.snackBar.success("Éligibilité lancée !\nVeuillez patienter, cela peut prendre jusqu'à plusieurs heures selon le volume de la requête.");
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.snackBar.error("Erreur rencontrée: " + err.error.detail);
      }
    });
  }

  close(): void {
    this.dialogRef.close(false);
  }
}
